export enum ContractType {
  SIM_CARD = 'sim_card',
  LORA_ACTIVATION = 'lora_activation',
  PLATFORM = 'platform',
  TECHNICAL_SERVICES = 'technical_services',
}

export enum ContractScope {
  STANDARD = 'standard',
  CLIENT = 'client',
}

export interface ContractActor {
  id: string;
  name: string;
  email: string;
}

export interface Contract {
  id: string;
  seq: number;
  type: ContractType;
  scope: ContractScope;
  accountId: string | null;
  proposalId: string | null;
  signerContactId: string | null;
  summary: Record<string, unknown>;
  clauses: Record<string, unknown>[];
  version: number;
  active: boolean;
  createdBy: ContractActor;
  lastModifiedBy: ContractActor | null;
  created_at: string;
  updated_at: string;
}

export interface ContractVersion {
  id: string;
  contractId: string;
  version: number;
  type: ContractType;
  summary: Record<string, unknown>;
  clauses: Record<string, unknown>[];
  accountName: string | null;
  accountDocument: string | null;
  signerName: string | null;
  signerDocumentation: string | null;
  publishedBy: ContractActor;
  publishedAt: string;
}

export type ContractSignatureProcessStatus =
  | 'pending'
  | 'draft'
  | 'running'
  | 'signed'
  | 'canceled'
  | 'expired'
  | 'error';

export interface ContractSignatureStatus {
  status: ContractSignatureProcessStatus;
  signer: {
    name: string;
    email: string;
    phone: string | null;
    documentation: string | null;
  };
  sentAt: string | null;
  signedAt: string | null;
  provider: 'clicksign';
  processId: string;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface ContractListParams {
  page?: number;
  limit?: number;
  type?: ContractType;
  scope?: ContractScope;
  accountId?: string;
  proposalId?: string;
  active?: boolean;
}

export interface PaginatedContracts<T> {
  docs: T[];
  total: number;
  pages: number;
  page: number;
  limit: number;
}

export interface CreateContractPayload {
  type: ContractType;
  scope: ContractScope;
  accountId?: string | null;
  proposalId?: string | null;
  signerContactId?: string | null;
  summary?: Record<string, unknown>;
  clauses?: Record<string, unknown>[];
  active?: boolean;
}

export type UpdateContractPayload = Partial<Omit<CreateContractPayload, 'active'>>;
